import createReactComponent from '../createReactComponent';
export default createReactComponent('dots-vertical', 'DotsVertical', [["path",{"d":"M12.25 12h-.5m.5-4h-.5m.5 8h-.5","key":"svg-0"}]]);